// extracted by mini-css-extract-plugin
module.exports = {"style":"index_style__3jvaS"};